import { render, staticRenderFns } from "./IconUserProfile.vue?vue&type=template&id=45b59cc6"
import script from "./IconUserProfile.vue?vue&type=script&lang=js"
export * from "./IconUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports